import React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';
import { routePaths } from 'router/route-paths.ts';
import { useCreateClient } from 'api/clients/use-create-client.ts';
import { UserRole, useRoleGuard } from 'shared/hooks/use-role-guard.ts';
import type { IClientFormFields } from 'components/clients/client-form';
import { ClientForm } from 'components/clients/client-form';
import { FormDrawerWithButton, EFormDrawerSize } from 'components/common/form-drawer-with-button';

export const CreateClient: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAllow = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.customer_manager]);

  const { mutateAsync: createClient, isLoading } = useCreateClient();

  const handleFinish = async (value: IClientFormFields) => {
    const result = await createClient(value);
    navigate(generatePath(routePaths.client, { clientId: String(result.id) }));
  };

  if (!isAllow) return null;

  return (
    <FormDrawerWithButton
      formComponent={ClientForm}
      formProps={{ isCreatingMode: true }}
      title={t('client:create_client')}
      buttonLabel={t('client:create_client')}
      size={EFormDrawerSize.MIDDLE}
      isLoading={isLoading}
      onFinish={handleFinish}
    />
  );
};
